<template>
  <div
    :class="componentClasses"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  variant: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-details-list',
  { [`is-${props.variant}`]: props.variant },
]);
</script>

<style>
.stk-details-list {
  display: flex;
  flex-direction: column;
  gap: 0.25em;

  &.is-boxed {
    background-color: var(--stk-background);
    border-radius: 0.5em;
    padding: 0.75em 1em;
  }
}
</style>
